export interface AudioProgressUpdatePayload {
    mediaKey: string;
    currentTimeSec: number;
    durationSec: number;
    progressPct: number;
}

export abstract class ExternalAudioPlayer {
    abstract init(): void;
    abstract destroy(): void;
    abstract play(mediaKey: string, url: string): Promise<void>;
    abstract stop(mediaKey: string): Promise<void>;
    abstract pause(mediaKey: string): Promise<void>;
    abstract setTime(mediaKey: string, timeSec: number): Promise<void>;
    abstract updateAudioProgress(progressUpdate: AudioProgressUpdatePayload): void;
}
